import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import moment from "moment";
import {GlobalDebugMode} from "@mnjsplatform/data";
import ModalWrapper from "@mnjsplatform/components/lib/common/modalWrapper";

class SMSAuthenticator extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            pinCode: "",
            isAuthenticated: false,
            showPinCodeForm: false,
            errorMessage: "",
            maxPinLength: 4,
            minPinLength: 4,
            timeToResend: moment.duration(props.resendPinInterval, "seconds")
        };
    }

    async componentDidMount() {
        console.log("SMSAuthenticator mounted");

        if (!GlobalDebugMode) {
            window.onbeforeunload = this.cleanPin;
            await this.initialize();
        }
    }

    componentWillUnmount() {
        console.log("SMSAuthenticator UnMount");
        if (!GlobalDebugMode) {
            this.cleanPin();
            window.removeEventListener('onbeforeunload', this.cleanPin);
        }
    }

    cleanPin = () => {
        if (!window.skipUnloadActions) this.props.dispatch(this.props.PersOffAuth_ClearPIN.execute({}, {newItem: true})); else window.skipUnloadActions = false;
    };

    initialize = async () => {
        const isPin = await this.checkAuth();
        this.setState({isAuthenticated: isPin}, async () => {
            if (!isPin) {
                if (await this.sendPin()) {
                    let timeToResend = moment.duration(this.props.resendPinInterval, "seconds");
                    let self = this;
                    this.setState({showPinCodeForm: true, timeToResend: timeToResend}, () => {
                        self.counter = setInterval(() => {
                            let timeToResend = self.state.timeToResend.subtract(1, "seconds");
                            if (timeToResend <= 0) clearInterval(self.counter);
                            self.setState({timeToResend: timeToResend});
                        }, 1000)
                    });
                }
            }
        });
    }

    checkAuth = async () => {
        await this.props.dispatch(this.props.PersOffAuth_CheckPINwithResult.execute({}, {newItem: true}));
        const isPin = this.props.PersOffAuth_CheckPINwithResult.getField(0, "IsPin") === 1;
        console.log("isPin: [" + isPin + "]");
        return isPin;
    }

    sendPin = async (e) => {
        e && e.preventDefault();
        await this.props.dispatch(this.props.PersOffAuth_SendPIN.execute({}, {newItem: true}));
        return !this.props.PersOffAuth_SendPIN.isError;
    }

    changePin = async (e) => {
        e && e.preventDefault();
        this.setState({pinCode: e.target.value});
    }

    confirmPin = async (e) => {
        e && e.preventDefault();
        await this.props.dispatch(this.props.PersOffAuth_ConfirmPIN.execute({PinCode: this.state.pinCode}, {newItem: true}));
        const isPin = this.props.PersOffAuth_ConfirmPIN.getField(0, "IsPin") === 1;
        console.log("isPin: [" + isPin + "]");
        if (isPin) this.setState({
            errorMessage: "",
            showPinCodeForm: false,
            isAuthenticated: true
        })
        else this.setState({errorMessage: i18next.t('InvalidPin'), pinCode: ""});
    }

    renderFooter = () => {
        return (<div className="modal-footer text-right">
            <button type="button" className="btn btn-regular -goescape ml1ex" data-dismiss="modal"
                    onClick={this.initialize} disabled={(this.state.timeToResend > 0)}>
                {i18next.t('SendAgain')}{this.state.timeToResend > 0 && <> - <span
                className="text-danger">{this.state.timeToResend.asSeconds()} seconds</span>
            </>}
            </button>
            <button type="submit" className="btn btn-regular -goahead  ml1ex" data-dismiss="modal"
                    onClick={this.confirmPin}>
                {i18next.t('Send')}
            </button>
        </div>)
    }

    renderPinCodeForm = () => {
        return (<ModalWrapper>
            <form className="formPin">
                <PopupWrapper popupVisible={true} title={i18next.t('PINChecking')} maxWidthBody="400px"
                              onClose={() => this.setState({showPinCodeForm: false})}
                              renderButtons={this.renderFooter}>
                    {<PlaceholderWrapper placeholderId="instruction" collapsed={false} canCollapse={false}
                                         showSplitterLine={false}>
                        {i18next.t(this.props.pinFormInstruction)}
                    </PlaceholderWrapper>}
                    <div className="row">
                        <div className="col-md-12">
                            <input type="text" className="form-control" placeholder="XXXX" required={true}
                                   autoFocus={true}
                                   ref={function (input) {
                                       if (input) setTimeout(() => {
                                           input.focus();
                                       }, 100)
                                   }}
                                   autoComplete="false" maxLength={this.state.maxPinLength}
                                   minLength={this.state.minPinLength}
                                   onChange={this.changePin} value={this.state.pinCode}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.errorMessage &&
                                <span className="text-danger">{this.state.errorMessage}</span>}&nbsp;
                        </div>
                    </div>
                </PopupWrapper>
            </form>
        </ModalWrapper>)
    }

    render() {
        return (<>
            {!GlobalDebugMode && this.state.showPinCodeForm && this.renderPinCodeForm()}
            {(GlobalDebugMode || this.state.isAuthenticated) && this.props.children}
            {!this.state.isAuthenticated && <div className="alert alert-danger" role="alert">
                {GlobalDebugMode && 'Debug - SMS auth is off - '}
                <button className="btn mn-btn-link"
                        onClick={() => window.location.reload()}>{i18next.t(this.props.accessInstruction)}</button>
            </div>}
        </>)
    }
}

SMSAuthenticator.propTypes = {
    dispatch: PropTypes.func.isRequired,
    PersOffAuth_SendPIN: PropTypes.object,
    PersOffAuth_ConfirmPIN: PropTypes.object,
    PersOffAuth_ClearPIN: PropTypes.object,
    PersOffAuth_CheckPINwithResult: PropTypes.object,
    accessInstruction: PropTypes.string,
    pinFormInstruction: PropTypes.string,
    resendPinInterval: PropTypes.number
};

SMSAuthenticator.defaultProps = {
    accessInstruction: "SMS_Authentication_Required",
    pinFormInstruction: "PIN_Form_Instruction",
    resendPinInterval: 60
}

function mapStateToProps(state, ownProps) {
    return {
        PersOffAuth_SendPIN: state.smsAuthState.PersOffAuth_SendPIN,
        PersOffAuth_ConfirmPIN: state.smsAuthState.PersOffAuth_ConfirmPIN,
        PersOffAuth_ClearPIN: state.smsAuthState.PersOffAuth_ClearPIN,
        PersOffAuth_CheckPINwithResult: state.smsAuthState.PersOffAuth_CheckPINwithResult
    };
}

export default withRouter(connect(mapStateToProps)(SMSAuthenticator));
